import { useState, useEffect, useRef } from "react";
import { useUser } from "../../contexts/UserContext";
import UserMenu from "./UserMenu/UserMenu";

import "./UserInfoDisplay.css";

export default function UserInfoDisplay() {
    // showMenu will be used to toggle the user menu
    const [showMenu, setShowMenu] = useState(false);

    // The user is required here to display their image and get their display name.
    const user = useUser()?.user;

    // menuRef is required to test the location of the user's clicks.
    const menuRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        // If the menu is not shown, none of the below code is necessary so there
        // is no need to create the listener.
        if (!menuRef.current) return;

        // The handleClickOutside only changes setShowMenu IF the menu shown.
        // This cannot be an anonymous function as it needs to be able to be
        // removed on redraw.
        const handleClickOutside = (ev: MouseEvent) => {
            if (
                menuRef.current &&
                !menuRef.current.contains(ev.target as Node)
            ) {
                setShowMenu(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);

        // Return a cleanup function to remove the listener and keep
        // the document as clean as possible.
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    });

    return (
        <div className="user-info-display">
            <img
                src={user?.profileImage ?? ""}
                onClick={() => {
                    setShowMenu((p) => !p);
                }}
                style={{ pointerEvents: "all", cursor: "pointer" }}
            />
            {showMenu && (
                <div
                    className="user-menu-root"
                    style={{ position: "relative" }}
                    ref={menuRef}
                >
                    <UserMenu />
                </div>
            )}
        </div>
    );
}
